module.exports = __webpack_public_path__ + "media/24_BL.0a4a5d73.mp3";